import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { EPlayerKanbanStatus, PLAYER_KANBAN_STATUS_LABELS, PLAYER_KANBAN_STATUS_COLORS, } from '../../../types';
import { KanbanPlayerCard } from '../../molecules/KanbanPlayerCard';
import { colors } from '../../../styles/colors';
const COLUMN_ORDER = [
    EPlayerKanbanStatus.NEW,
    EPlayerKanbanStatus.PROCESSED,
    EPlayerKanbanStatus.BOOKED,
    EPlayerKanbanStatus.PLAYED,
];
export const PlayersKanban = ({ players, onPlayerClick, onStatusChange, }) => {
    const columns = useMemo(() => {
        return COLUMN_ORDER.map((status) => ({
            id: status,
            title: PLAYER_KANBAN_STATUS_LABELS[status],
            color: PLAYER_KANBAN_STATUS_COLORS[status],
            items: players.filter((p) => {
                var _a;
                const effectiveStatus = (_a = p.overriddenStatus) !== null && _a !== void 0 ? _a : p.computedStatus;
                return effectiveStatus === status;
            }),
        }));
    }, [players]);
    return (_jsx(Box, Object.assign({ sx: {
            display: 'flex',
            gap: '16px',
            overflowX: 'auto',
            paddingBottom: '16px',
            // smooth horizontal scroll on touch devices
            WebkitOverflowScrolling: 'touch',
            '&::-webkit-scrollbar': {
                height: '6px',
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: colors.secondary,
                borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: colors.secondaryLight,
                borderRadius: '3px',
            },
        } }, { children: columns.map((column) => (_jsx(KanbanColumn, { column: column, onPlayerClick: onPlayerClick, onStatusChange: onStatusChange }, column.id))) })));
};
const KanbanColumn = ({ column, onPlayerClick }) => {
    return (_jsxs(Box, Object.assign({ sx: {
            minWidth: '260px',
            maxWidth: '300px',
            flex: '0 0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '0',
            backgroundColor: colors.surface,
            borderRadius: '12px',
            overflow: 'hidden',
            border: `1px solid ${colors.cardBorder}`,
        } }, { children: [_jsxs(Box, Object.assign({ sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '14px 16px',
                    borderBottom: `1px solid ${colors.cardBorder}`,
                    backgroundColor: colors.secondaryDark,
                } }, { children: [_jsx(Box, { sx: {
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: column.color,
                            flexShrink: 0,
                            boxShadow: `0 0 6px ${column.color}`,
                        } }), _jsx(Typography, Object.assign({ sx: {
                            fontWeight: 600,
                            fontSize: '14px',
                            color: colors.textPrimary,
                            flexGrow: 1,
                        } }, { children: column.title })), _jsx(Box, Object.assign({ sx: {
                            backgroundColor: colors.secondaryLight,
                            color: colors.textSecondary,
                            borderRadius: '12px',
                            padding: '2px 8px',
                            fontSize: '12px',
                            fontWeight: 600,
                            minWidth: '24px',
                            textAlign: 'center',
                        } }, { children: column.items.length }))] })), _jsx(Box, Object.assign({ sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    padding: '12px',
                    minHeight: '120px',
                    overflowY: 'auto',
                    maxHeight: 'calc(100vh - 280px)',
                    '&::-webkit-scrollbar': {
                        width: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: colors.secondaryLight,
                        borderRadius: '2px',
                    },
                } }, { children: column.items.length === 0 ? (_jsx(Box, Object.assign({ sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '80px',
                        color: colors.textHint,
                        fontSize: '13px',
                        fontStyle: 'italic',
                    } }, { children: "\u041D\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u043E\u0432" }))) : (column.items.map((kanbanPlayer) => (_jsx(KanbanPlayerCard, { kanbanPlayer: kanbanPlayer, onClick: onPlayerClick }, kanbanPlayer.id)))) }))] })));
};
